// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__aAtgO","location":"Header_location__35oaH"};